// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\CustomerStatsResponse

export type CustomerStatsApiResponse = {
	totalCustomers: number;
	totalPhoneOptIn: number;
	totalEmailOptIn: number;
	averageSpent: number;
	averageBookings: number;
};

export type CustomerStats = {
	totalCustomers: number;
	totalPhoneOptIn: number;
	totalEmailOptIn: number;
	averageSpent: number;
	averageBookings: number;
};

export function hydrateCustomerStats(data: CustomerStatsApiResponse): CustomerStats {
	return { ...data };
}